// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mkb-inline-colour .mkb-swatch{width:15px;height:15px;border-radius:50%}@media(max-width:767.98px){.mkb-inline-colour .mkb-swatch{width:20px;height:20px}}", ""]);
// Exports
module.exports = exports;
